import { inmuebleService } from "../../../_services/inmuebles.service";
import { dashboardConstants } from "../constants";

export const getInmuebles = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await inmuebleService.getInmuebles(data);

    if (!Array.isArray(response)) {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED, payload: { inmueblesList: [] } };
  }
  function failure(error) {
    console.error(error);
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.SET_INMUEBLES_LIST, payload: list };
  }
};

export const deleteInmueble = (id) => async (dispatch) => {
  dispatch(request());
  try {
    const data = inmuebleService.deleteInmueble(id);

    if (typeof data === "string") {
      dispatch(failure(data));
    } else {
      dispatch(success(data));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }
  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(error) {
    console.error(error);
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(payload) {
    return { type: dashboardConstants.SET_INMUEBLES_LIST, payload };
  }
};

export const showTable = () => async (dispatch) => { 
  return dispatch({ type: dashboardConstants.SHOW_TABLE });  
};

export const clearInmuebles = () => async (dispatch) => { 
  return dispatch({ type: dashboardConstants.CLEAR_INMUEBLES_LIST });  
};

export const setInmuebles = (payload) => async (dispatch) => { 
  return dispatch({ type: dashboardConstants.SET_INMUEBLES_LIST, payload });  
};
